import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import BSPagination from "../../Components/pagination";
import { useNavigate } from "react-router-dom";
import {
  deleteProviderById,
  paginatedProvidersList,
  searchProviders,
  toggleProviderStatus,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import AddEditProviderModal from "./addEditGameProviderModal";
import ProviderDetailsModal from "./viewProviderModal";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const GameProvidersList = ({
  gameProviders,
  setGameProviders,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const columns = [
    { data: "name", title: "Name" },
    { data: "email", title: "Email" },
    { data: "website", title: "Website" },
    { data: "phone_number", title: "Phone Number" },
    // { data: "status", title: "Status" },
    // { data: "id", title: "Action",}
  ];
  const tableRef = useRef(null);

  const fetchProviders = async (pgntn, str = "") => {
    const res = await paginatedProvidersList(
      pgntn.currentPage,
      pgntn.pageSize,
      str
    );
    if (res?.data?.success) {
      setGameProviders(res.data.data);
      res.data.pagination && setPagination(res.data.pagination);
    } else {
      handleErrors(res, navigate, "Providers list:");
    }
  };

  useEffect(() => {
    fetchProviders(pagination, query);
  }, [pagination.currentPage, pagination.pageSize]);

  const handleSearch = (e) => {
    const str = e.target.value;
    setQuery(str);
    setPagination({ ...pagination, currentPage: 1 });
    if (str) {
      searchProviders(str).then((res) => {
        if (res?.data?.success) {
          setGameProviders(res.data.data);
          res.data.pagination && setPagination(res.data.pagination);
        } else {
          handleErrors(res, navigate, "Search Providers:");
        }
      });
    } else {
      fetchProviders(pagination);
    }
  };

  const handlePageChange = (page) => {
    setPagination({ ...pagination, currentPage: page });
  };

  const handleStatusChange = (prov) => {
    if (!granted.some((p) => p.type === "toggle-status")) {
      return toast.error("You don't have neccessary permissions to do this operation..");
    }
    setModalOptions({
      header: "Change Status",
      body: `Change status of \"${prov.name}\"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: prov.id, status: prov.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const res = await toggleProviderStatus(data);
    if (res?.data?.success) {
      fetchProviders(pagination, query);
      toast.success("Provider status updated.");
      setShowOptionsModal(false);
    } else {
      handleErrors(res, navigate, "Change Status:");
    }
  };

  const handleDelete = (prov) => {
    if (!granted.some((p) => p.type === "delete")) return;
    setModalOptions({
      header: "Delete Provider",
      body: `Delete \"${prov.name}\"?`,
      okay: "Delete",
      method: deleteProvider,
      data: { id: prov.id },
    });
    setShowOptionsModal(true);
  };

  const deleteProvider = async (data) => {
    const res = await deleteProviderById(data.id);
    if (res?.data?.success) {
      fetchProviders(pagination, query);
      toast.success("Provider deleted.");
      setShowOptionsModal(false);
    } else {
      handleErrors(res, navigate, "Delete Provider:");
    }
  };

  const handleOpenAddEditModal = (prov) => {
    setSelectedProvider(prov);
    setShowModal(true);
  };

  const handleView = (prov) => {
    setSelectedProvider(prov);
    setOpenDetailsModal(true);
  };

  useEffect(() => {
    if (!tableRef.current) return;

    const rows = gameProviders.map((g) => ({
      name: g.name,
      email: g.contact_email,
      website: g.website,
      phone: g.phone,
      statusHtml: `<button class="btn btn-sm ${
        g.status === 1 ? "text-success" : "text-danger"
      }" data-id="${g.id}" title="change status">${g.status === 1 ? "Active" : "Inactive"}</button>`,
      actionHtml:
        `<button class="btn btn-sm btn-outline-success view-btn me-1" data-id="${g.id}" title="view details"><i class="fas fa-eye"></i></button>` +
        (granted.some((p) => p.type === "update")
          ? `<button class="btn btn-sm btn-outline-primary edit-btn me-1" data-id="${g.id}" title="edit"><i class="fas fa-edit"></i></button>`
          : "") +
        (granted.some((p) => p.type === "delete") &&
        g.is_associated === 0 &&
        g?.status === 0
          ? `<button class="btn btn-sm btn-outline-danger delete-btn" data-id="${g.id}" title="delete"><i class="fas fa-trash-alt"></i></button>`
          : ""),
    }));

    const config = {
      data: rows,
      columns: [
        { title: "Name", data: "name" },
        { title: "Email", data: "email" },
        { title: "Website", data: "website" },
        { title: "Phone Number", data: "phone" },
        { title: "Status", data: "statusHtml", orderable: false },
        {
          title: "Action",
          data: "actionHtml",
          orderable: false,
          className: "text-right",
        },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
      autoWidth: false,
    };

    const $tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $tbl.DataTable().clear().destroy();
      $tbl.find("tbody").empty();
    }
    $tbl.DataTable(config);

    // Attach click handlers
    $tbl
      .off("click", ".view-btn")
      .on("click", ".view-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        handleView(gameProviders.find((g) => g.id === id));
      })
      .off("click", ".edit-btn")
      .on("click", ".edit-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        handleOpenAddEditModal(gameProviders.find((g) => g.id === id));
      })
      .off("click", ".delete-btn")
      .on("click", ".delete-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        handleDelete(gameProviders.find((g) => g.id === id));
      })
      .off("click", "button[data-id]")
      .on("click", "button[data-id]", (e) => {
        if (
          $(e.currentTarget).hasClass("btn-sm") &&
          !$(e.currentTarget).hasClass("edit-btn") &&
          !$(e.currentTarget).hasClass("delete-btn") &&
          !$(e.currentTarget).hasClass("view-btn")
        ) {
          const id = +$(e.currentTarget).data("id");
          handleStatusChange(gameProviders.find((g) => g.id === id));
        }
      });
  }, [gameProviders, granted]);

  return (
    <div className="container py-4 text-light bg-dark p-3 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-4">
          <Form.Control
            type="text"
            placeholder="Search Providers..."
            value={query}
            onChange={(e) => {
              handleSearch(e);
            }}
            className="form-control bg-dark text-light border-light input-placeholder-light"
            style={{ width: "45%" }}
          />
        </div>
        <div className="col-md-8 text-end">
          {granted?.some((perm) => perm?.type === "create") && (
            <Button
              title="Add New Provider"
              className="btn btn-success"
              onClick={() => {
                handleOpenAddEditModal({});
              }}
            >
              Add Game Provider
            </Button>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped table-dark w-100"
        />
      </div>

      <div className="d-flex justify-content-end mt-2">
        <div className="mx-4 py-2">
          <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
        </div>
        <BSPagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
          siblingCount={2}
          showFirstLast
        />
      </div>

      <AddEditProviderModal
        selectedProvider={selectedProvider}
        setSelectedProvider={setSelectedProvider}
        showModal={showModal}
        setShowModal={setShowModal}
        fetchProviders={fetchProviders}
        pagination={pagination}
      />

      <ProviderDetailsModal
        selectedProvider={selectedProvider}
        setSelectedProvider={setSelectedProvider}
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
      />

      <Modal
        show={showOptionsModal}
        onHide={() => setShowOptionsModal(false)}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">{modalOptions.body}</Modal.Body>
        <Modal.Footer className="bg-dark border-0">
          <Button
            variant="secondary"
            onClick={() => setShowOptionsModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => modalOptions.method(modalOptions.data)}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GameProvidersList;
